export default {
  SET_ORDERRETURN(state, payload) {
    state.orderReturnDetails = payload;
  },
  SET_SELECTED_ORDERRETURN(state, payload) {
    state.selectedOrderReturn = payload;
  },
};
